module.exports = __webpack_public_path__ + "img/klarna-data.3a710f5b.svg";